<template>
  <v-container fluid tag="section">
    <v-row class="pt-4 px-12">
      <h1 style="font-size: x-large; flex: 1;">{{title}}</h1>
      <h2 v-if="challenges.length === 0" style="width: 100%; margin-top: 32px">Empty</h2>
      <v-row style="flex: unset" v-else>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
              <v-btn
                icon
                x-large
                :ripple="false"
                class="mr-4"
                v-on="on"
                @click="viewMode = 'grid'"
              >
                <v-icon color="black" x-large>mdi-view-grid-outline</v-icon>
              </v-btn>
          </template>
          <span> Grid View</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              x-large
              :ripple="false"
              v-on="on"
              @click="viewMode = 'list'"
            >
              <v-icon color="black" x-large>mdi-format-list-bulleted</v-icon>
            </v-btn>
          </template>
          <span> List View</span>
        </v-tooltip>
      </v-row>
    </v-row>
    <div v-if="challengesLoaded && challenges.length > 0">
      <v-expansion-panels multiple v-model="panels">
        <v-expansion-panel
          expand
          v-model="panels"
          v-for="(groupChallenges, groupId) in challenges"
          :key="groupId"
        >
          <v-expansion-panel-header>
            <h1>{{ groupChallenges.organization.name }}</h1>
          </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row justify="center" >
                  <ChallengeTable
                    v-if="viewMode === 'list'"
                    :challenges="groupChallenges.challenges"
                    :options="dropdownOptions"
                    :archived="archivePage"
                    @action="$emit('action',$event)" />
                  <ChallengeCard
                    v-for="challenge in groupChallenges.challenges"
                    :key="challenge.uuid"
                    :challenge="challenge"
                    :archived="archivePage"
                    :options="dropdownOptions"
                    @action="$emit('action',$event)"
                    v-else
                  />
                </v-row>
                <v-row justify="center" style="margin-top:36px;">
                  <v-select
                    :items="[5, 10, 15, 25, 50]"
                    v-model="pageInfos[groupChallenges.organization.uuid].pageSize"
                    label="Page Size"
                    style="max-width: 80px; padding-right: 12px;"
                    dense
                    @input="requestDifferentPageSize(groupChallenges.organization.uuid)"
                  />
                  <h4 style="line-height:40px;">Page {{pageInfos[groupChallenges.organization.uuid].pageNum}} of {{pageInfos[groupChallenges.organization.uuid].numPages}} </h4>
                  <v-btn
                    :disabled="pageInfos[groupChallenges.organization.uuid].pageNum <= 1"
                    icon
                    @click="requestDifferentPage(pageInfos[groupChallenges.organization.uuid].pageNum - 1, groupChallenges.organization.uuid)">
                      <v-icon>
                      mdi-chevron-left
                      </v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="pageInfos[groupChallenges.organization.uuid].pageNum >= pageInfos[groupChallenges.organization.uuid].numPages"
                    icon
                    @click="requestDifferentPage(pageInfos[groupChallenges.organization.uuid].pageNum + 1, groupChallenges.organization.uuid)">
                      <v-icon>
                      mdi-chevron-right
                      </v-icon>
                  </v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
  </v-container>
</template>

<script>

export default {
  name: 'ChallengeListing',

  props: ['title', 'challenges', 'archivePage', 'challengesLoaded', 'dropdownOptions', 'pageInfos'],

  components: {
    ChallengeCard: () => import('@/components/challenge/challengeList/ChallengeCard'),
    ChallengeTable: () => import('@/components/challenge/challengeList/ChallengeTable')
  },

  data: () => ({
    viewMode: 'grid',
    panels: [0]
  }),

  computed: {
    allOrganizationsEmpty () {
      return this.challenges.every((c) => c.challenges.length === 0)
    },

    challengesNotEmpty () {
      return this.challenges.filter(c => c.challenges.length > 0)
    }
  },

  methods: {
    requestDifferentPage (pageNum, orgId) {
      this.pageInfos[orgId].pageNum = pageNum
      this.$emit('newPage', { pageNum: this.pageInfos[orgId].pageNum, pageSize: this.pageInfos[orgId].pageSize, orgId: orgId })
      // Note that since the challenges are stored in the store, they are global so we don't need to pass stuff back and forth
    },

    requestDifferentPageSize (orgId) {
      this.$emit('newPage', { pageNum: 1, pageSize: this.pageInfos[orgId].pageSize, orgId: orgId })
      // Note that since the challenges are stored in the store, they are global so we don't need to pass stuff back and forth
      // Note 2: page num is 1 to avoid breaking server (specifically is you are on page n with page size m then switch to page
      // size i such that i > m and page n is not defined, server returns an error)
    }
  }
}
</script>
